import PropTypes from 'prop-types';

import { IMPERFECT_THEME_DOMAIN, MISFITS_THEME_DOMAIN } from 'constants/theme';

export function PersonalCare({ brand, isActive, width }) {
    const soapColor = brand === MISFITS_THEME_DOMAIN ? '#B0BDCD' : '#63ACDE';
    const activeColor = brand === MISFITS_THEME_DOMAIN ? '#D7E1B8' : '#F0D3E3';

    return isActive ? (
        <svg width={width} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_6088_2271)">
                <path
                    d="M14.6505 28.7652C21.902 26.9646 29 22.6358 29 14.9992C29 7.3625 22.9452 2.7363 14.6505 1.1728C7.31233 -0.213857 2.48978 6.96057 1.13553 14.967C-0.132106 22.475 7.73356 30.4815 14.6505 28.7652Z"
                    fill={activeColor}
                />
                <g clipPath="url(#clip1_6088_2271)">
                    <path
                        d="M13.6157 7.96318C11.6802 8.45981 9.65667 8.41355 7.6627 8.36248C5.79039 8.31192 3.63478 8.38841 2.47618 9.86318C1.54401 11.0479 1.44621 12.8164 2.08331 14.182C4.73929 19.8698 1.65725 21.7278 4.49162 24.4588C5.35618 25.291 6.74719 25.2475 7.93327 25.0651C10.266 24.7065 13.5186 23.3375 15.8288 22.8408C18.2954 22.3086 21.86 22.6112 24.3362 22.1382C25.5356 21.913 26.8134 21.4219 27.3671 20.3391C27.6588 19.7649 27.7422 19.0929 27.7087 18.4499C27.4835 14.505 25.8366 15.5931 26.0099 10.2968C26.0815 8.11716 25.1776 6.48089 23.9075 5.8969C20.5273 4.35879 16.7673 7.15763 13.6157 7.96318Z"
                        fill={soapColor}
                        stroke="#2D2D2D"
                        strokeWidth="0.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M9.31955 12.3892C8.40672 12.8819 7.53606 13.5096 6.98987 14.3885C6.44368 15.2674 6.27932 16.4389 6.79014 17.3386C7.10346 17.8956 7.64592 18.3039 8.20357 18.6186C11.633 20.5844 16.0238 19.8613 19.5707 18.1203C20.6315 17.6035 21.7012 16.9537 22.317 15.9419C24.2471 12.7918 20.6652 11.5094 18.2915 11.0539C15.2674 10.461 12.0367 10.9045 9.32942 12.3876L9.31955 12.3892Z"
                        stroke="#2D2D2D"
                        strokeWidth="0.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M6.56474 22.0657C5.23962 22.0782 4.30653 22.6958 3.8313 23.5125C1.63224 23.7581 1.27694 26.5613 3.32303 27.1206C3.76805 27.2408 4.23198 27.1655 4.64545 26.9667C4.87011 27.1024 5.12118 27.2136 5.40692 27.2888C6.17051 27.4991 6.95882 27.3002 7.61316 26.9001C9.50362 25.7523 9.31529 22.0344 6.57301 22.0542L6.56474 22.0657Z"
                        fill="white"
                        stroke="#2D2D2D"
                        strokeWidth="0.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M8.45341 26.8348C8.87709 26.9484 9.31486 26.8368 9.67417 26.6163C10.7158 25.9812 10.6159 23.9307 9.09682 23.9342C7.13381 23.949 6.75549 26.3608 8.4518 26.825L8.45341 26.8348Z"
                        fill="white"
                        stroke="#2D2D2D"
                        strokeWidth="0.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M20.9171 7.44626C21.4532 7.81512 22.1204 7.86887 22.726 7.73001C24.4835 7.32306 25.3402 4.11425 23.1509 3.60862C21.3722 3.19841 18.7598 5.95272 20.9171 7.44626Z"
                        fill="white"
                        stroke="#2D2D2D"
                        strokeWidth="0.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M26.1229 6.43904C26.3967 6.6276 26.7238 6.6454 27.0266 6.57598C27.9053 6.3725 28.3345 4.77303 27.239 4.51528C26.3554 4.31431 25.0378 5.6832 26.1213 6.42917L26.1229 6.43904Z"
                        fill="white"
                        stroke="#2D2D2D"
                        strokeWidth="0.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </g>
            </g>
            <defs>
                <clipPath id="clip0_6088_2271">
                    <rect width="30" height="30" fill="white" />
                </clipPath>
                <clipPath id="clip1_6088_2271">
                    <rect
                        width="29.35"
                        height="21.37"
                        fill="white"
                        transform="translate(-1.26929 7.19922) rotate(-9.2231)"
                    />
                </clipPath>
            </defs>
        </svg>
    ) : (
        <svg width={width} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_6088_2250)">
                <g clipPath="url(#clip1_6088_2250)">
                    <path
                        d="M14.8234 7.849C12.8334 8.029 10.8434 7.659 8.88337 7.289C7.04337 6.939 4.90337 6.669 3.52337 7.939C2.41337 8.959 2.03337 10.689 2.44337 12.139C4.15337 18.179 0.813368 19.519 3.17337 22.669C3.89337 23.629 5.27337 23.809 6.47337 23.819C8.83337 23.839 12.2634 23.009 14.6234 22.889C17.1434 22.759 20.6134 23.629 23.1334 23.559C24.3534 23.529 25.6934 23.249 26.4134 22.269C26.7934 21.749 26.9834 21.099 27.0534 20.459C27.4634 16.529 25.6634 17.339 26.6834 12.139C27.1034 9.999 26.4734 8.239 25.3134 7.459C22.2234 5.399 18.0634 7.559 14.8234 7.849Z"
                        fill={soapColor}
                        stroke="#2D2D2D"
                        strokeWidth="0.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M9.87352 11.5291C8.89352 11.8691 7.93352 12.3491 7.25352 13.1291C6.57352 13.9091 6.22352 15.0391 6.58352 16.0091C6.80352 16.6091 7.27352 17.0991 7.77352 17.4991C10.8435 19.9891 15.2935 19.9791 19.0735 18.8291C20.2035 18.4891 21.3635 18.0191 22.1335 17.1191C24.5435 14.3191 21.2135 12.4791 18.9435 11.6491C16.0535 10.5791 12.7935 10.4991 9.88352 11.5291H9.87352Z"
                        stroke="#2D2D2D"
                        strokeWidth="0.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M5.60339 20.6392C4.29339 20.4392 3.27339 20.8992 2.67339 21.6292C0.463388 21.5192 -0.336612 24.2292 1.59339 25.1092C2.01339 25.2992 2.48339 25.2992 2.92339 25.1692C3.12339 25.3392 3.35339 25.4892 3.62339 25.6092C4.34339 25.9392 5.15339 25.8692 5.86339 25.5792C7.91339 24.7492 8.32339 21.0492 5.61339 20.6292L5.60339 20.6392Z"
                        fill="white"
                        stroke="#2D2D2D"
                        strokeWidth="0.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M6.70328 25.6494C7.10328 25.8294 7.55328 25.7894 7.94328 25.6294C9.07328 25.1694 9.30328 23.1294 7.80328 22.8894C5.86328 22.5894 5.10328 24.9094 6.70328 25.6394V25.6494Z"
                        fill="white"
                        stroke="#2D2D2D"
                        strokeWidth="0.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M22.1133 8.50899C22.5833 8.95899 23.2333 9.11899 23.8533 9.07899C25.6533 8.95899 27.0133 5.92899 24.9333 5.07899C23.2433 4.38899 20.2233 6.68899 22.1133 8.50899Z"
                        fill="white"
                        stroke="#2D2D2D"
                        strokeWidth="0.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M27.4133 8.34885C27.6533 8.57885 27.9733 8.64885 28.2833 8.62885C29.1833 8.56885 29.8633 7.05885 28.8233 6.62885C27.9833 6.28885 26.4633 7.42885 27.4133 8.33885V8.34885Z"
                        fill="white"
                        stroke="#2D2D2D"
                        strokeWidth="0.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </g>
            </g>
            <defs>
                <clipPath id="clip0_6088_2250">
                    <rect width="30" height="30" fill="white" />
                </clipPath>
                <clipPath id="clip1_6088_2250">
                    <rect width="29.35" height="21.37" fill="white" transform="translate(0.253418 4.70898)" />
                </clipPath>
            </defs>
        </svg>
    );
}

PersonalCare.propTypes = {
    brand: PropTypes.oneOf([IMPERFECT_THEME_DOMAIN, MISFITS_THEME_DOMAIN]).isRequired,
    isActive: PropTypes.bool,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

PersonalCare.defaultProps = {
    isActive: false,
    width: 30,
};
